import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateSmashThroughWall extends PlayerState {
    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.SmashThroughWall);
    }

    beginState(): void {
        super.beginState();
        this.player.once(Player.ON_PASSED_WALL, this.player.evalFlight, this);
    }

    update(dt: number): void {
        this.player.img.angle += dt * 200;
        // console.log(this.player.img.angle);
    }

    shutDown(): void {
        super.shutDown();
        this.player.img.angle = 0;
        this.player.off(Player.ON_PASSED_WALL, this.player.evalFlight, this);
    }

    finalCleanup(): void {
        super.finalCleanup();
        this.player.off(Player.ON_PASSED_WALL, this.player.evalFlight, this);
    }
}